"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfScheduleSelection = instanceOfScheduleSelection;
exports.ScheduleSelectionFromJSON = ScheduleSelectionFromJSON;
exports.ScheduleSelectionFromJSONTyped = ScheduleSelectionFromJSONTyped;
exports.ScheduleSelectionToJSON = ScheduleSelectionToJSON;
exports.ScheduleSelectionToJSONTyped = ScheduleSelectionToJSONTyped;
/**
 * Check if a given object implements the ScheduleSelection interface.
 */
function instanceOfScheduleSelection(value) {
    return true;
}
function ScheduleSelectionFromJSON(json) {
    return ScheduleSelectionFromJSONTyped(json, false);
}
function ScheduleSelectionFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'weekDay': json['weekDay'] == null ? undefined : json['weekDay'],
        'sessionNo': json['sessionNo'] == null ? undefined : json['sessionNo'],
    };
}
function ScheduleSelectionToJSON(json) {
    return ScheduleSelectionToJSONTyped(json, false);
}
function ScheduleSelectionToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'weekDay': value['weekDay'],
        'sessionNo': value['sessionNo'],
    };
}
